export default __webpack_public_path__ + "static/media/Call_Icon.95900156.svg";